import React, { useState } from "react";
import { css } from "emotion";
import BoxBankDetails from "../../../shared/create-offer/BoxBankDetails/BoxBankDetails";
import BoxFidelityProgramDetails from "../../../shared/create-offer/BoxFidelityProgramDetails/BoxFidelityProgramDetails";
import CardInfoFidelityProgramDetails from "../../../shared/create-offer/CardInfoFidelityProgramDetails/CardInfoFidelityProgramDetails";
import {
	ItemCardInfoDefault,
	ItemCardInfoPhoneMultiplus,
	ItemCardInfoBank,
	ItemCardInfoRescuePassMultiplus
} from "../../../shared/create-offer/ItemsCardInfoFidelityProgramDetails/";
import Loading from "../../../shared/Loading/Loading";
import { useNewOffer } from "../../context/new-offer";

import { loadingStyle, pageRegistrationData } from "./style";
import LayoutSticky from "../molecules/LayoutSticky";
import { ItemCardInfo2FA } from "../../../shared/create-offer/ItemsCardInfoFidelityProgramDetails/ItemCardInfo2FA";
import { GOL_FIDELITY_PROGRAM } from "../../../../js/shared/constants";

const RegistrationData = props => {
	const [state, setState] = useState({
		inputInFocus: ""
	});
	const {
		userData,
		bankData,
		loyaltyData,
		setBankData,
		setLoyaltyData,
		rankingData,
		banks,
		newOfferTempData,
		setNewOfferTempData,
		phoneMultiplus,
		participantData,
		airlineProgramsSettings,
		email2FAStatusValidation,
		offerData,
		status2FAEnabledFeature,
		request2FACodeLatam,
		hasClickedRequest2FACode,
		setHasClickedRequest2FACode,
		hasTriedToProceedWithout2FA,
		twoFactorData
	} = useNewOffer();

	const setInputInFocus = component => {
		let temp = {
			...state,
			inputInFocus: component
		};

		setState(temp);
	};

	const setLoyaltyDataFn = data => {
		setLoyaltyData({
			...loyaltyData,
			data: { ...loyaltyData.data, ...data }
		});
	};

	const setBankDataFn = data => {
		setBankData({
			...bankData,
			data: { ...bankData.data, ...data }
		});
	};

	// 2FA para Gol
	const golAirlineProgramsSettings =
		airlineProgramsSettings &&
		Object.values(airlineProgramsSettings).find(
			item => item.idAirlinesProgram === GOL_FIDELITY_PROGRAM
		);

	const renderCardInfo = () => {
		const typePhoneLatam = loyaltyData?.data?.phoneRequiredMode;
		const inputInFocusValidation = typePhoneLatam !== 1 ? "phone" : "phoneDisabled";
		switch (state.inputInFocus) {
			case "bankId":
			case "cpfcnpj":
			case "agency":
			case "account":
				return <ItemCardInfoBank />;
			case "pwAwardSecondary":
				return <ItemCardInfoRescuePassMultiplus />;
			case "twoFactorAuthenticationStrategy":
				return (
					<ItemCardInfo2FA
						title={golAirlineProgramsSettings.helpTitle}
						description={golAirlineProgramsSettings.helpDescription}
					/>
				);
			case inputInFocusValidation:
				return <ItemCardInfoPhoneMultiplus phoneMultiplus={phoneMultiplus} />;
			default:
				return <ItemCardInfoDefault fidelityProgram={props.fidelityProgram} />;
		}
	};

	const checkData = (box, value) => {
		setNewOfferTempData({
			...newOfferTempData,
			form: {
				...newOfferTempData.form,
				[box]: value
			}
		});
	};

	const embeded = props.embeded;

	return userData.isFetching || rankingData.isFetching ? (
		<div
			className={css`
				${loadingStyle};
			`}
		>
			<Loading width={120} height={120} />
		</div>
	) : (
		<div
			className={css`
				${pageRegistrationData(embeded)}
			`}
		>
			<div className="row">
				<div className={embeded ? "col-xs-16" : "col-xs-9"}>
					<BoxFidelityProgramDetails
						checkData={checkData}
						inputInFocus={props.inputInFocus || state.inputInFocus}
						setData={setLoyaltyDataFn}
						setInputInFocus={props.setInputInFocus || setInputInFocus}
						fidelityProgram={props.fidelityProgram}
						userData={loyaltyData.data}
						phoneMMSuggestion={phoneMultiplus}
						airlineProgramsSettings={airlineProgramsSettings}
						email2FAStatusValidation={email2FAStatusValidation}
						offerData={offerData}
						status2FAEnabledFeature={status2FAEnabledFeature}
						request2FACodeLatam={request2FACodeLatam}
						hasClickedRequest2FACode={hasClickedRequest2FACode}
						setHasClickedRequest2FACode={setHasClickedRequest2FACode}
						twoFactorData={twoFactorData}
						hasTriedToProceedWithout2FA={hasTriedToProceedWithout2FA}
					/>
					{!participantData.hasManagementActive && (
						<BoxBankDetails
							checkData={checkData}
							className="new-offers--registration-data"
							options={banks.data}
							setInputInFocus={props.setInputInFocus || setInputInFocus}
							setData={setBankDataFn}
							bankData={bankData.data}
						/>
					)}
					{props.children}
				</div>
				{!embeded && (
					<div className="col-xs-7">
						<LayoutSticky>
							<CardInfoFidelityProgramDetails children={renderCardInfo()} />
						</LayoutSticky>
					</div>
				)}
			</div>
		</div>
	);
};

export default RegistrationData;
